export const BASE_URL = "https://rest.uat.godaylight.com/api/v1/";
export const LOGIN_URL = `${BASE_URL}admin/login/`;
export const GET_LIST = `${BASE_URL}get/texture/device/`